<template>
    <v-text-field
      :label="label"
      :value="formattedText()"
      v-on:input="updateText"
      :required=required
      :rules = "rulesMerged"
      :error-messages = "errorsMerged" 
      :readonly="readonly"
      :hint=hint
 ></v-text-field>
</template>

<script>
  export default {
    name: 'number-field',
    props: {
      value: {
        type: Number,
        default: null
      },
      hint: {
        type: String,
        default: null
      },
      readonly: {
        type: Boolean,
        default: false
      },
      required: {
        type: Boolean,
        default: false
      },
      rules: {
        type: Array,
        default () {
          return []
        }
      },
      errorMessages: {
        type: Array,
        default () {
          return []
        }
      },
      label: String
    },
    data: function () {
      return {
        menu: null,
        val: null,
        valText: null,
        errors: [],
        dateRules: {
          required: v => !!v || 'введите число'
        }
      }
    },
    mounted () {
      this.val = this.value
      this.valText = this.formattedText()
    },
    watch: {
      value: function (newVal, oldVal) {
        if (newVal !== oldVal) {
          this.val = newVal
        }
        this.valText = this.formattedText()
      }
    },
    computed: {
      rulesMerged () {
        var result = [this.dateRules.required]
        result = this.rules.concat(result)
        return result
      },
      errorsMerged () {
        var result = this.errors
        result = this.errorMessages.concat(result)
        return result
      },
      locale () {
        return navigator.languages && navigator.languages.length > 0 ? navigator.languages[0] : 'en-en'
      }
    },
    methods: {
      formattedText () {
        this.valText = this.val != null ? this.val.toLocaleString(this.locale, {minimumFractionDigits: 0, maximumFractionDigits: 2}) : ''
        return this.valText
      },
      updateText: function (v) {
        console.log('updateText', 'this.value', this.value, 'value: ', v)
        if (v) {
          var r = v != null ? v.match(/[0-9\s]+[,.]?[0-9]?[0-9]?$/) : null
          if (r != null && r[0].length === v.length) {
            this.valText = v
            this.errors = []
            v = v.replace(',', '.')
            v = v.replace(/\s/g, '')
            this.val = Number(v)
            this.$emit('input', this.val)
          } else {
            this.errors.push('Неверный формат числа')
          }
        } else {
          this.val = null
          this.$emit('input', this.val)
        }
      }
    }
  }
</script>

<style>
  
</style>


// WEBPACK FOOTER //
// NumberField.vue?c868f97e